// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rT-z","hovered":"sT-z","hoverImage":"tT-z","mainImage":"uT-z","imageNoBackground":"vT-z","fullSizeImage":"wT-z"};